(() => {
  'use strict';

  const MEASUREMENT_ID = 'G-E3CCDJTZJT';
  const ACQUISITION_KEY = 'studio-cosy-acquisition-v2';
  let enabled = false;
  let initialised = false;

  const readAcquisition = () => {
    try {
      const stored = sessionStorage.getItem(ACQUISITION_KEY);
      if (stored) return JSON.parse(stored);
    } catch (_) {}
    const query = new URLSearchParams(location.search);
    let referrer = '';
    try {
      const url = document.referrer ? new URL(document.referrer) : null;
      if (url && url.hostname !== location.hostname) referrer = url.hostname.replace(/^www\./, '');
    } catch (_) {}
    let source = query.get('utm_source') || '';
    let medium = query.get('utm_medium') || '';
    if (!source && query.get('gclid')) { source = 'google'; medium = 'cpc'; }
    if (!source && query.get('fbclid')) { source = 'meta'; medium = 'paid_social'; }
    if (!source && referrer) { source = referrer; medium = 'referral'; }
    if (!source) { source = 'direct'; medium = 'none'; }
    const value = {
      source,
      medium,
      campaign: query.get('utm_campaign') || '(not set)',
      landing_page: `${location.pathname}${location.search}`
    };
    try { sessionStorage.setItem(ACQUISITION_KEY, JSON.stringify(value)); } catch (_) {}
    return value;
  };

  const acquisition = readAcquisition();
  const deviceGroup = () => innerWidth < 768 ? 'mobile' : innerWidth < 1024 ? 'tablet' : 'desktop';
  const base = () => ({
    source_channel: acquisition.source,
    source_medium: acquisition.medium,
    source_campaign: acquisition.campaign,
    landing_page: acquisition.landing_page,
    device_group: deviceGroup(),
    page_type: document.body?.className?.match(/template-([\w-]+)/)?.[1] || 'unknown'
  });

  const track = (eventName, parameters = {}) => {
    if (!enabled || typeof window.gtag !== 'function') return false;
    window.gtag('event', eventName, { ...base(), ...parameters });
    return true;
  };

  const productData = (root = document.querySelector('[data-sc-product]')) => ({
    product_id: root?.dataset.productId || '',
    product_handle: root?.dataset.productHandle || '',
    product_title: root?.querySelector('h1')?.textContent?.trim() || ''
  });

  const itemFromProduct = (root) => {
    const product = productData(root);
    return { item_id: product.product_id || product.product_handle, item_name: product.product_title };
  };

  const initialiseTracking = () => {
    if (initialised) return;
    initialised = true;
    const product = document.querySelector('[data-sc-product]');
    if (product) {
      const details = productData(product);
      track('view_item', { ...details, items: [itemFromProduct(product)] });
      track('studio_cosy_product_view', details);

      let activeSince = document.visibilityState === 'visible' ? Date.now() : 0;
      let activeMs = 0;
      const pause = () => { if (activeSince) { activeMs += Date.now() - activeSince; activeSince = 0; } };
      const resume = () => { if (!activeSince) activeSince = Date.now(); };
      document.addEventListener('visibilitychange', () => document.hidden ? pause() : resume());
      window.addEventListener('pagehide', () => {
        pause();
        if (activeMs >= 1000) track('studio_cosy_product_engagement', { ...details, engaged_seconds: Math.round(activeMs / 1000) });
      }, { once: true });
    }

    const firedScroll = new Set();
    const onScroll = () => {
      const height = document.documentElement.scrollHeight - innerHeight;
      if (height <= 0) return;
      const depth = Math.round((scrollY / height) * 100);
      [25, 50, 75, 90].forEach((mark) => {
        if (depth >= mark && !firedScroll.has(mark)) {
          firedScroll.add(mark);
          track('studio_cosy_scroll_depth', { scroll_percent: mark });
        }
      });
    };
    addEventListener('scroll', onScroll, { passive: true });

    document.addEventListener('studio-cosy:add-to-cart', (event) => {
      const detail = event.detail || {};
      const item = { item_id: detail.product_id || detail.product_handle, item_name: detail.product_title, quantity: detail.quantity || 1 };
      track('add_to_cart', { ...detail, items: [item] });
      track('studio_cosy_add_to_cart', detail);
    });

    document.addEventListener('studio-cosy:delivery-date-saved', (event) => {
      const value = event.detail?.value || '';
      const date = value ? new Date(`${value}T12:00:00`) : null;
      track('studio_cosy_delivery_date_selected', {
        delivery_weekday: date ? date.toLocaleDateString('nl-NL', { weekday: 'long' }) : '',
        delivery_is_saturday: Boolean(date && date.getDay() === 6),
        delivery_days_ahead: date ? Math.round((date - new Date(new Date().setHours(12, 0, 0, 0))) / 86400000) : 0,
        source_component: event.target?.matches?.('[data-sc-delivery-date]') ? 'product_page' : 'cart'
      });
    });

    document.addEventListener('studio-cosy:fabric-sample-complete', (event) => {
      track('generate_lead', { lead_type: 'stofstalen', ...(event.detail || {}) });
      track('studio_cosy_fabric_sample_complete', event.detail || {});
    });

    const formStarted = new WeakSet();
    document.addEventListener('focusin', (event) => {
      const form = event.target.closest('form');
      if (!form || formStarted.has(form) || form.closest('[data-sc-product-form]')) return;
      formStarted.add(form);
      const type = form.matches('[data-sc-sample-form], #StofstalenForm') ? 'stofstalen' :
        form.querySelector('[value="Interieuradvies"]') ? 'interieuradvies' : 'contact';
      track('form_start', { form_type: type, form_id: form.id || '(geen)' });
      if (type === 'stofstalen') track('studio_cosy_fabric_sample_start', { ...productData(), source_component: form.matches('#StofstalenForm') ? 'stofstalen_page' : 'product_modal' });
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.matches('[data-sc-product-form]')) return;
      const type = form.matches('[data-sc-sample-form], #StofstalenForm') ? 'stofstalen' :
        form.querySelector('[value="Interieuradvies"]') ? 'interieuradvies' : 'contact';
      track('studio_cosy_form_submit', { form_type: type, form_id: form.id || '(geen)' });
    }, true);

    document.addEventListener('click', (event) => {
      const target = event.target.closest('a,button,summary');
      if (!target) return;
      if (target.matches('[data-sc-sample-open]')) {
        track('studio_cosy_fabric_sample_open', { ...productData(), source_component: target.dataset.source || 'unknown' });
      }
      if (target.matches('[data-cart-open]')) track('view_cart', { source_component: 'header' });
      if (target.matches('[name="checkout"]')) track('begin_checkout', { source_component: target.closest('[data-cart-page]') ? 'cart_page' : 'cart_drawer' });
      if (target.matches('[data-cart-quantity]')) {
        track(Number(target.dataset.quantity) === 0 ? 'remove_from_cart' : 'studio_cosy_cart_quantity_change', { requested_quantity: Number(target.dataset.quantity), source_component: target.closest('[data-cart-page]') ? 'cart_page' : 'cart_drawer' });
      }
      if (target.matches('.product-card')) track('select_item', { item_name: target.querySelector('h3')?.textContent?.trim() || '', source_component: 'product_grid' });
      if (target.matches('[data-menu-toggle]')) track('studio_cosy_mobile_menu_open');
      if (target.matches('[data-sc-gallery-prev],[data-sc-gallery-next]')) track('studio_cosy_product_gallery', { direction: target.matches('[data-sc-gallery-next]') ? 'next' : 'previous' });
      if (target.matches('[data-sc-wishlist]')) track('add_to_wishlist', productData());
      if (target.matches('details summary')) track('studio_cosy_faq_open', { question: target.textContent.trim().replace(/\s+/g, ' ').slice(0, 100) });
      const href = target.getAttribute('href') || '';
      if (/^tel:/.test(href)) track('studio_cosy_contact_click', { contact_method: 'phone' });
      if (/^mailto:/.test(href)) track('studio_cosy_contact_click', { contact_method: 'email' });
      if (/wa\.me|whatsapp/i.test(href)) track('studio_cosy_contact_click', { contact_method: 'whatsapp' });
      if (/google\.com\/maps/.test(href)) track('studio_cosy_route_click');
    }, true);

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (input.matches('[data-sc-variant-select], [name="id"]')) track('studio_cosy_variant_select', { ...productData(), variant_id: input.value });
      if (input.matches('[data-samples-product]')) track('studio_cosy_fabric_sample_product_select', { selected_product: input.value });
    });

    if (document.querySelector('[data-cart-page]')) track('view_cart', { source_component: 'cart_page' });
    if (location.search.includes('contact_posted=true')) track('generate_lead', { lead_type: document.querySelector('#StofstalenForm') ? 'stofstalen' : 'contact' });
  };

  const enable = () => {
    if (enabled) return;
    enabled = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', MEASUREMENT_ID, {
      send_page_view: true,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      cookie_flags: 'SameSite=None;Secure'
    });
    if (!document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}"]`)) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
      document.head.appendChild(script);
    }
    initialiseTracking();
  };

  const consentAllowed = () => {
    try { return Boolean(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()); } catch (_) { return false; }
  };
  const checkConsent = () => { if (consentAllowed()) enable(); };
  document.addEventListener('visitorConsentCollected', checkConsent);
  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], checkConsent);
  } else {
    addEventListener('load', checkConsent, { once: true });
  }

  window.StudioCosyAnalytics = { track, measurementId: MEASUREMENT_ID, consentAllowed };
})();
